import styled from "styled-components";
import Invitations from "./page";

export default styled(Invitations)``;
